import { render, staticRenderFns } from "./WorkspaceDetails.vue?vue&type=template&id=3719bc9b&scoped=true"
import script from "./WorkspaceDetails.vue?vue&type=script&lang=js"
export * from "./WorkspaceDetails.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceDetails.vue?vue&type=style&index=0&id=3719bc9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3719bc9b",
  null
  
)

export default component.exports